import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { OverflowScroller } from "../../overflow-scroller/OverflowScroller";
import { TableWithData } from "../table-with-data/TableWithData";
import * as Styled from "./Table.styled";
export const Table = forwardRef((props, ref) => {
    const { children, data, scrollProps, withoutScroller, sortIndex, sortDirection, createSortMethodFor, ...otherProps } = props;
    const ComponentToRender = withoutScroller ? Styled.OverflowCssWrapper : OverflowScroller;
    const defaultScrollProps = withoutScroller ? scrollProps : { xAxis: { offset: 25 }, ...scrollProps };
    return (_jsx(ComponentToRender, { ...defaultScrollProps, children: _jsx(Styled.Table, { "data-testid": "Table", ref: ref, ...otherProps, children: data ? (_jsx(TableWithData, { data: data, sortIndex: sortIndex, sortDirection: sortDirection, createSortMethodFor: createSortMethodFor, children: children })) : (children) }) }));
});
Table.displayName = "Table";
